<div class="flex flex-col items-center gap-2 w-full max-w-xl">
  <div class="flex items-center gap-2 w-full">
    <div *ngIf="svgIcon"
      class="w-7 h-7 rounded-sm bg-accent text-accent-contrast flex items-center justify-center shrink-0">
      <mat-icon [svgIcon]="svgIcon" class="icon-sm"></mat-icon>
    </div>
    <span class="font-bold text-lg text-title">{{ title ?? (titleKey | translate) }}</span>
  </div>
  <p *ngIf="subtitleBoldKey" class="font-semibold text-default-gray text-center m-0">{{ subtitleBoldKey | translate }}</p>
  <p *ngIf="subtitleLightKey" class="text-light-gray text-sm text-center m-0">{{ subtitleLightKey | translate }}</p>
</div>
